var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-gray",
      attrs: { "justify-content-center": "", wrap: "" },
    },
    [
      _c(
        "v-flex",
        { staticClass: "bg-white main-layout", attrs: { xs12: "" } },
        [
          _vm.forceReload
            ? _c("DashboardChart", {
                ref: "dashboard",
                on: { rangeDate: _vm.updateRangeDate },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(
            _vm.trackingUserSummaries,
            function (trackingUserSummary, index) {
              return _c(
                "div",
                { key: index, staticClass: "mb-2" },
                [
                  _c("div", { staticClass: "ps-4 p-2" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.dateFormat(
                            trackingUserSummary.trackingUser.trackingDate
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ps-2 d-flex border-top border-bottom" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-right d-flex p-2",
                          style: { width: _vm.mobile ? "40%" : "200px" },
                        },
                        [
                          _c("div", { staticClass: "align-center" }, [
                            _c("div", [
                              _c("span", { staticClass: "text-h4" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.timeValueToHour(
                                        trackingUserSummary.trackingUser
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-caption caption-margin" },
                                [_vm._v("時間")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-h4" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.timeValueToMinutes(
                                        trackingUserSummary.trackingUser
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-caption caption-margin" },
                                [_vm._v("分")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-caption text-gray" },
                              [_vm._v("\n              学習時間\n            ")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-1 ms-2" },
                            [
                              _c("UserTrackingChangeDialog", {
                                attrs: {
                                  tracking: trackingUserSummary.trackingUser,
                                  update: _vm.updateTracking,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "border-right p-2",
                          style: { width: _vm.mobile ? "30%" : "150px" },
                        },
                        [
                          _c("div", { staticClass: "ps-4 align-center" }, [
                            _c("div", [
                              _c("span", { staticClass: "text-h4" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      trackingUserSummary.activities.length
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-caption caption-margin" },
                                [_vm._v("レッスン")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-caption text-gray" },
                              [
                                _vm._v(
                                  "\n              学習完了数\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(
                    trackingUserSummary.activities,
                    function (activity, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("div", { staticClass: "d-flex p-2 ps-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "text-gray",
                                style: { width: "85px" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.timeFormat(activity.createdAt)) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ms-4" },
                              [
                                activity.link
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "link-text",
                                          attrs: {
                                            id: "activity-link-" + activity.id,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.saveNavigationPath(
                                                activity.link,
                                                activity.id.toString()
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(activity.title) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : activity.externalLink
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: activity.externalLink,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(activity.title) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(activity.title) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "link-not-found" },
                                        [_vm._v("リンクが無効になりました")]
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-divider"),
                        ],
                        1
                      )
                    }
                  ),
                ],
                2
              )
            }
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [
                  _c("v-progress-circular", {
                    attrs: { size: 50, color: "primary", indeterminate: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading && _vm.totalPages > 1
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center my-4" },
                [
                  _c("v-pagination", {
                    attrs: {
                      value: _vm.page + 1,
                      length: _vm.totalPages,
                      "total-visible": 5,
                    },
                    on: { input: _vm.onPageChange },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }